export function stripNamespacePrefix<T extends null | undefined | "">(name: T): T;
export function stripNamespacePrefix(name: string): string;
export function stripNamespacePrefix(name: unknown): unknown {
  if (!name) return name;
  const value = String(name);
  const slash = value.lastIndexOf("/");
  return slash >= 0 ? value.slice(slash + 1) : value;
}
